import { useContext } from 'react'

import { Trans } from '@lingui/react'

import type { Navigation } from '@twisto/api-cms'
import {
  ModalActions,
  ModalContent,
  ModalNavigation,
  SideModal,
} from '@twisto/components/atoms/modal'

import { NestedLinksContext } from '../nested-links-provider'
import { PrimaryComponents } from '../primary/components/primary-components'
import { SecondaryComponents } from '../secondary/components/secondary-components'

import * as styles from './modal.styles'

type Props = {
  opened: boolean
  primaryComponents: Navigation['primary']
  secondaryComponents: Navigation['secondary']
  onClose: () => void
}

const modalTitleId = 'id-modal-navigation'

export const Modal = ({
  opened,
  onClose,
  primaryComponents,
  secondaryComponents,
}: Props) => {
  const { closeList, currentActiveListId } =
    useContext(NestedLinksContext) ?? {}

  return (
    <SideModal
      aria-labelledby={modalTitleId}
      opened={opened}
      onClickOutside={onClose}
    >
      <ModalNavigation
        backButtonProps={{
          onClick: () => {
            closeList && closeList()
          },
        }}
        modalCloser={{
          onClick: onClose,
        }}
        title={<Trans id="navigation.modal.title" />}
      />
      <nav>
        <ModalContent>
          <ul css={styles.primaryContainer}>
            <PrimaryComponents
              increaseFontSize={true}
              primaryNavigationContent={primaryComponents}
            />
          </ul>
        </ModalContent>
        {!currentActiveListId && (
          <ModalActions>
            <ul css={styles.secondaryContainer}>
              <SecondaryComponents
                increaseFontSize={true}
                secondaryNavigationContent={secondaryComponents}
              />
            </ul>
          </ModalActions>
        )}
      </nav>
    </SideModal>
  )
}
